import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  pdfBox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "4px",
    backgroundColor: "#D0D5DD",
    cursor: "pointer",
  },
}))

export default styles
